// extracted by mini-css-extract-plugin
export var avatarContainer = "_96-0";
export var avatarTypingWave = "_96-i";
export var gray = "_96-f";
export var green = "_96-c";
export var icon = "_96-9";
export var image = "_96-1";
export var lg = "_96-6";
export var md = "_96-5";
export var presenceDot = "_96-b";
export var red = "_96-d";
export var sm = "_96-4";
export var status = "_96-a";
export var typingDot = "_96-h";
export var typingPill = "_96-g";
export var xl = "_96-7";
export var xs = "_96-3";
export var xxl = "_96-8";
export var xxs = "_96-2";
export var yellow = "_96-e";